export default "__VITE_ASSET__CRd1ieCy__"